export { default as AdapterSupportService } from './AdapterSupportService'; 
